<!--
Summit Logo     Home|Content Lib|Achievements                           User drop down

Summit Logo             Hamburger Menu
                            - Home
                            - Content Lib
                            - Achievements
                            - Account Information
                            - Sign out
-->

<script>
import { link, push, location } from 'svelte-spa-router';
import { curUser } from '../user.js'
import * as user from '../user.js'
import * as utils from '../utils';
import Button from './button.svelte';

let userState = 'no_session';
curUser.subscribe((u) =>
{
   if (u && u.auth)
   {
       userState = 'signed_in';
   }
   else
   {
       userState = 'no_session';
   }
});

let showMenu = false;
function CloseMenu()
{
    showMenu = false;
}

function ShowMenu()
{
    showMenu = true;
}


function Go(where)
{
    console.log('what am I doing?');
    CloseMenu();
    push(where);
}

const J = "javascript:void(0)";

</script>

<header id="alternate-header">
    <a href="/#/signin" class="login-link">Sign In</a>
</header>


<style>
#alternate-header {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  padding: 1.5em 4em;
  display: flex;
  justify-content: flex-end;
}

a.login-link {
  color: #c5c5c5;
  border-bottom: none !important;
}

a.login-link:hover {
  color: #fff !important;
  border-bottom: none !important;
}

@media screen and (max-width: 736px) {
  #alternate-header {
    padding: 1.5em 1.5em 0 1.5em;
  }
}

@media screen and (max-width: 480px) {
  #alternate-header {
    padding: 1.5em 1em;
  }
}


</style>
